import React from 'react';
import { Button } from '@mui/material';
import Iconify from '@/components//Iconify';
import useTicketsContext from '@/contexts/tickets/useTicketsContext';

function BackButton({ onClick, sx = {} }) {
  const { callBackAction } = useTicketsContext();
  const onBackHandler = () => {
    callBackAction(onClick);
  }
  return (
    <Button
      sx={{
        'minWidth': '8px',
        'position': 'absolute',
        'top': '20px',
        'left': '24px',
        'width': '40px',
        'height': '40px',
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'background': (theme) => theme.palette.grey[50],
        'border': (theme) => `0.988169px solid ${theme.palette.grey[400]}`,
        'borderRadius': '50%',
        'padding': 0,
        '&:hover': {
          cursor: 'pointer',
        },
        ...sx,
      }}
      onClick={onBackHandler}
    >
      <Iconify
        width={16}
        height={16}
        icon={'mdi:arrow-left'}
        sx={{ color: (theme) => theme.palette.grey[800] }}
      />
    </Button>
  );
}

export default BackButton;
